import { render, staticRenderFns } from "./Contacts.view.vue?vue&type=template&id=4e56db54&"
import script from "./Contacts.view.vue?vue&type=script&lang=js&"
export * from "./Contacts.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports